import { createContext } from 'react';
import { BANNERS_STORAGE_KEYS } from './helpers';

export const AppBannersContext = createContext<{
  displayGrowDiscountBanner: boolean;
  displayGermanProPlanDiscountBanner: boolean;
  displayTRIALBanner: boolean;
  displayBelgiumPeppolVerificationBanner: boolean;
  dismissBanner: (dismissKey: BANNERS_STORAGE_KEYS) => void;
}>({} as any);
